import {
    Button,
    Box,
    Typography,
} from '@mui/material';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { useEffect, useState } from 'react';
import { SelectRowFromTable, SelectColumnFromTableRow } from '../universal/Axios';
import { GenAlgIndividualTable } from './GenAlgIndividualTable';

const EditGenAlgGeneration = () => {
    const queryParameters = new URLSearchParams(window.location.search)
    const id = queryParameters.get("id")
    const [backURL, setBackURL] = useState("")
    const [forwardURL, setForwardURL] = useState("")
    const [genAlgRunID, setGenAlgRunID] = useState(undefined)
    const [genAlgGenerationObject, setGenAlgGenerationObject] = useState([])
    const [prevGenAlgGenerationID, setPrevGenAlgGenerationID] = useState(undefined)
    const [nextGenAlgGenerationID, setNextGenAlgGenerationID] = useState(undefined)


    let BackLink = () =>
        <Button
            sx={{ marginLeft: '20px', textTransform: 'none', width: "140px" }}
            variant="contained"
            href={backURL}
        >
            {prevGenAlgGenerationID === undefined ? "ALL GENS" : "PREV GEN"}
        </Button>

    let ForwardLink = () =>
        <Button
            sx={{ marginLeft: '20px', textTransform: 'none', width: "140px" }}
            variant="contained"
            href={forwardURL}
        >
            {nextGenAlgGenerationID === undefined ? "ALL GENS" : "NEXT GEN"}
        </Button>

    useEffect(() => {
        if (prevGenAlgGenerationID !== undefined) {
            setBackURL("edit-gen-alg-generation?id=" + prevGenAlgGenerationID)
        } else {
            setBackURL("edit-gen-alg-run?id=" + genAlgRunID)
        }
    }, [prevGenAlgGenerationID, genAlgRunID]);

    useEffect(() => {
        if (nextGenAlgGenerationID !== undefined) {
            setForwardURL("edit-gen-alg-generation?id=" + nextGenAlgGenerationID)
        } else {
            setForwardURL("edit-gen-alg-run?id=" + genAlgRunID)
        }
    }, [nextGenAlgGenerationID, genAlgRunID]);
    useEffect(() => {
        if (genAlgGenerationObject !== undefined && "gen_alg_run_id" in genAlgGenerationObject) {
            setGenAlgRunID(genAlgGenerationObject["gen_alg_run_id"])
        }
    }, [genAlgGenerationObject])

    useEffect(() => {
        if (genAlgRunID !== undefined && genAlgGenerationObject != null && "generation_number" in genAlgGenerationObject) {
            SelectColumnFromTableRow("select id from gen_alg_generation where gen_alg_run_id = '" + genAlgRunID + "' and generation_number = " + (genAlgGenerationObject["generation_number"] - 1) + ";", "id", setPrevGenAlgGenerationID)
            SelectColumnFromTableRow("select id from gen_alg_generation where gen_alg_run_id = '" + genAlgRunID + "' and generation_number = " + (genAlgGenerationObject["generation_number"] + 1) + ";", "id", setNextGenAlgGenerationID)
        }
    }, [genAlgRunID, genAlgGenerationObject]);

    useEffect(() => {
        SelectRowFromTable("select gag.*, nb.median_si_sdr, nb.average_si_sdr from gen_alg_generation gag join network_batch nb on gag.network_batch_id = nb.id where gag.id = '" + id + "';", setGenAlgGenerationObject)
    }, []);


    return (
        <Box>
            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                <Box>
                    <Typography variant="h6">{id}</Typography>
                </Box>
            </Box>
            <Box sx={{ float: "right", marginTop: "15px" }}>
                <BackLink />
                <ForwardLink/>
            </Box>
            <Box sx={{ display: "flex", justifyContent: "center", margin: '20px', fontSize: '20px' }}>
                {genAlgGenerationObject !== undefined && <b>Generation {genAlgGenerationObject["generation_number"]}</b>}
            </Box>
            <Box style={{ height: 400, width: '100%' }}>
                <GenAlgIndividualTable gen_alg_generation_id={id} />
            </Box>
            <Box sx={{ marginTop: '20px', marginLeft: '10px', fontSize: '20px', height: '50px' }}>
                <Box sx={{ textAlign: "left", margin: "auto", display: "inline-block", fontSize: '20px' }}>
                    <span sx={{ float: "left" }}><b>Info:</b></span>
                </Box>
            </Box>  
            <TableContainer component={Paper}>
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                    <TableHead>
                        <TableRow>
                            <TableCell>{<b>Property</b>}</TableCell>
                            <TableCell>{<b>Value</b>}</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <TableRow>
                            <TableCell>Network Batch</TableCell>
                            <TableCell>{<a
                                href={'edit-network-batch?id=' + genAlgGenerationObject.network_batch_id}
                            >{genAlgGenerationObject.network_batch_id}</a>}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>Mean SI-SDR</TableCell>
                            <TableCell>
                                {genAlgGenerationObject.average_si_sdr}
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>Median SI-SDR</TableCell>
                            <TableCell>
                                {genAlgGenerationObject.median_si_sdr}
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>Generation Number</TableCell>
                            <TableCell>
                                {genAlgGenerationObject.generation_number}
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>Created Date</TableCell>
                            <TableCell>
                                {genAlgGenerationObject.created_date}
                            </TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </TableContainer>
        </Box>
    )
}

export default EditGenAlgGeneration